import { loadMicrosoftClarity } from '@lib/microsoft-clarity';
import { loadFacebookPixel } from '@lib/facebook-pixel';
import { isBrowserCompatible } from './boot';
import { isProduction } from '@lib/environments.const';

export function initializeNonUserLibs(): void {
  if (isBrowserCompatible()) {
    loadMicrosoftClarity();
  }
}

export function initializeUserLibs(): void {
  if (isProduction()) {
    loadFacebookPixel();
  }
}